/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { GA4_EVENT_VIEW_ITEM_LIST, PAGE_DATA_LAYER } from '@/data/constants/gtm';
import { getGTMCarouselItemListViewEventData } from '@/data/events/data/gtm/CarouselItemListView';
import { getGTMConfig } from '@/data/events/handlers/gtm';
import { GTMCarouselItemListViewPayload } from '@/data/types/GTM';
import { error as logError } from '@/data/utils/loggerUtil';
import TagManager from 'react-gtm-module';

/**
 * Measure the carousel item list viewed (PDP - Completa tu look).
 *
 * @param data transformed input payload from carousel-item-list-viewed event (see data-type)
 */
export const measure_GA4 = async (
	data: Awaited<ReturnType<typeof getGTMCarouselItemListViewEventData>>
) => {
	const dataLayerName = PAGE_DATA_LAYER;

	TagManager.dataLayer({
		dataLayer: { ecommerce: null },
		dataLayerName,
	});

	TagManager.dataLayer({
		dataLayer: {
			event: GA4_EVENT_VIEW_ITEM_LIST,
			...data,
		},
		dataLayerName,
	});
};

export const sendGTMCarouselItemListViewEvent = async (
	payload: GTMCarouselItemListViewPayload
) => {
	const { ga4 } = getGTMConfig(payload.settings);

	if (ga4) {
		const data = await getGTMCarouselItemListViewEventData(payload);
		try {
			await measure_GA4(data);
		} catch (error) {
			logError(
				undefined,
				'CarouselItemListView: sendGTMCarouselItemListViewEvent: measure_GA4: error: %o',
				error
			);
		}
	}
};
